/// <reference path="../../app.typings.d.ts" />
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var Modals;
    (function (Modals) {
        var ConfirmModalController = /** @class */ (function (_super) {
            __extends(ConfirmModalController, _super);
            function ConfirmModalController($uibModalInstance, modalOptions) {
                var _this = _super.call(this, $uibModalInstance) || this;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalOptions = modalOptions;
                return _this;
            }
            ConfirmModalController.$inject = [
                '$uibModalInstance',
                'modalOptions'
            ];
            return ConfirmModalController;
        }(Modals.BaseModalController));
        Modals.ConfirmModalController = ConfirmModalController;
        angular.module('app.Modals')
            .controller('ConfirmModalController', ConfirmModalController);
    })(Modals = app.Modals || (app.Modals = {}));
})(app || (app = {}));
